import { getApolloClient } from '../lib/getApolloClient';
import { InboxItem } from '../generated/gql-types';
import {
  GET_INBOX_ITEM,
  GET_UNREAD_INBOX_ITEMS_FOR_OWNER,
  MARK_INBOX_ITEM_AS_READ,
} from './inboxItem.gql';

const getUnreadInboxItemsForOwner = async (
  ownerId: string,
): Promise<InboxItem[]> => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_UNREAD_INBOX_ITEMS_FOR_OWNER,
      variables: { ownerId },
      fetchPolicy: 'network-only',
    });
    return data.getInboxForOwner ?? [];
  } catch (error) {
    console.error('Error fetching inbox items for owner:', error);
    throw error;
  }
};

const getInboxItem = async (inboxItemId: string): Promise<InboxItem> => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_INBOX_ITEM,
      variables: { id: inboxItemId },
      fetchPolicy: 'network-only',
    });
    if (!data?.getInboxItem) {
      throw new Error('Inbox item not found');
    }
    return data.getInboxItem;
  } catch (error) {
    console.error('Error fetching inbox item:', error);
    throw error;
  }
};

const markInboxItemAsRead = async (inboxItemId: string): Promise<boolean> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: MARK_INBOX_ITEM_AS_READ,
      variables: { id: inboxItemId },
    });
    return data.markInboxItemAsRead;
  } catch (error) {
    console.error('Error marking inbox item as read:', error);
    throw error;
  }
};

export const inboxItemActions = {
  getUnreadInboxItemsForOwner,
  getInboxItem,
  markInboxItemAsRead,
};
